.root {
  gap: 0.75rem;
  border-radius: var(--border-radius__sm);
  display: inline-flex;

  /* https://react-spectrum.adobe.com/react-aria/VisuallyHidden.html#gotchas */
  /* https://github.com/adobe/react-spectrum/pull/8091 */
  position: relative;
}

.root:not([data-disabled]) {
  cursor: pointer;
}

.root[data-disabled] {
  cursor: not-allowed;
}

/* prettier-ignore */
.radio:not(:is([data-selected], [data-invalid], [data-disabled])) {
  background-color: var(--color__white);
  color: var(--ds-radio-deselected-color);
}

/* prettier-ignore */
.radio[data-disabled]:not(:is([data-selected])) {
  color: var(--ds-radio-disabled-color);
}

/* prettier-ignore */
.radio[data-disabled]:is([data-selected]) {
  background-color: var(--color__white);
  color: var(--ds-radio-disabled-color);
}

/* prettier-ignore */
.radio:is([data-selected]):not(:is([data-disabled], [data-invalid])) {
  background-color: var(--color__white);
  color: var(--ds-radio-selected-color);
}

/* prettier-ignore */
.radio[data-invalid]:not([data-disabled]) {
  color: var(--ds-radio-invalid-color);
}

/* prettier-ignore */
.radio[data-invalid]:not([data-disabled]):is([data-selected]) {
  background-color: var(--color__white);
}

.radio {
  --ds-radio-deselected-color: var(--color__gray-400);
  /* Same selected-control lilac as Checkbox — see DESIGN.md, Every colour has one job. */
  --ds-radio-selected-color: var(--color__lilac-500);
  --ds-radio-invalid-color: var(--color__red-400);
  --ds-radio-disabled-color: var(--color__gray-300);

  inline-size: 1rem;
  block-size: 1rem;
  border-radius: var(--border-radius__full);
  border: 2px solid currentColor;
  transition:
    border-color 200ms,
    background-color 200ms;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkmark {
  inline-size: 0.5rem;
  block-size: 0.5rem;
  border-radius: inherit;
  background-color: currentColor;
  transition: opacity 200ms;
}

.root:not([data-selected]) .checkmark {
  opacity: 0;
}

.root[data-selected] .checkmark {
  opacity: 1;
}

.alignment-center {
  align-items: center;
}

.alignment-top {
  align-items: baseline;
}
